let token = ''
export function getToken(){
    return token
}
export function setToken(newToken) {
    token = newToken
}